module.exports = __webpack_public_path__ + "media/images/247-va-95b58f2c887fa5366e866e6be77368f8.png";